import SearchIcon from "@mui/icons-material/Search";
import Link from "@mui/material/Link";
import { useDispatch } from "react-redux";
import { applyFilter } from "../redux/search";

const SearchLink = (props) => {
  const dispatch = useDispatch();
  const [id, value] = props.href.split("://");

  const onClick = () => {
    dispatch(applyFilter({ id, value }));
  };

  return id && value ? (
    <Link component="button" onClick={onClick} sx={{ display: "flex" }}>
      {props.children}
      <SearchIcon
        sx={{ height: "18px", float: "right", alignSelf: "center" }}
      />
    </Link>
  ) : (
    props.children
  );
};

export default SearchLink;
